module.exports = __webpack_public_path__ + "static/media/landelijk.b45c6a58.jpg";